import React from "react";
import { Timeline, Button } from "antd";
import { useSelector, useDispatch } from 'react-redux'
import { fetchGlobalNews } from '../config/actions'

const NewsComponent = () => {
	const dispatch = useDispatch()
	const timelines = useSelector(state => state.data.globalNews) || []
    const [showAll, setShowAll] = React.useState(false)

	React.useEffect(() => {
		fetchGlobalNews()(dispatch)
	}, [dispatch]);

	return (
		<div style={{ paddingLeft: 10, paddingRight: 10 }}>
			<div class="flex-row mb-3 bold aCenter"><div class='blinking' style={{width: 10,height:10,borderRadius: 5, backgroundColor: 'red', marginRight: 8}} />Live Global News</div>
			<Timeline>
				{timelines.slice(0, showAll ? 1000 : 10).map((item, index) => {
					return (
						<Timeline.Item onClick={() => window.open(item.url, '_blank')} color="#ccc" key={`${index}`}>
							<div class="flex-row jSb light-text">
								<div class='bold'>
									{item.timestamp}, {item.country}
								</div>
								<div class='bold'>{item.source}</div>
							</div>
							<p class='mt-1 bold'>{item.title}</p>
						</Timeline.Item>
					);
				})}
			</Timeline>
            {!showAll && (<div style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end'}}>
				<Button onClick={() => setShowAll(true)} type="link">Show more updates</Button>
			</div>)}
		</div>
	);
};

export default NewsComponent;
